__turbopack_context__.v({
  "avatar": "Avatar-module__-mrGRq__avatar",
  "icon": "Avatar-module__-mrGRq__icon",
  "selected": "Avatar-module__-mrGRq__selected",
});
